import { network } from 'services/network';

export const getEmailNotificationStatus = () => {
    return network.get('api/bo/notification/getEmailNotificationStatus').then((response) => {
        return response.data;
    });
};
